import Cookies from 'js-cookie';
import type { SupportedCountry } from '@archipro-website/localisation';
import {
    getCountryHrefLang,
    isSupported,
} from '@archipro-website/localisation';

/**
 * The region the visitor's connection geolocates to (e.g. "Canterbury"), from
 * the `__ap_location` cookie. Undefined when the cookie is missing or not
 * readable from the page.
 */
export const getUserRegion = (): string | undefined => {
    const location = Cookies.get('__ap_location') || '';
    const [, , region] = location.split('|');
    const trimmed = region?.trim();
    return trimmed && trimmed !== 'undefined' ? trimmed : undefined;
};

export const getSiteLang = (country: SupportedCountry): string => {
    if (!isSupported(country)) {
        throw new Error(`Unknown country provided to getSiteLang: ${country}`);
    }
    // Derived from the shared country config so new markets work automatically.
    return getCountryHrefLang(country);
};
